<template>
    <C1Button
        type="button"
        variant="primary"
        @click.stop.prevent="applyNow()"
        size="lg"
        class="af-btn-apply afu-font-bold"
        :class="isCompleteApply && !canReapplyJob ? 'apply-btn-disabled' : ''"
        :disabled="isCompleteApply && !canReapplyJob"
    >
        <template
            v-if="isCompleteApply"
        >
            <span v-if="canReapplyJob">{{ $t('label.apply_again') }}</span>
            <span v-else>{{ $t('label.applied') }} {{ jobAppliedTime }}</span>
        </template>
        <template
            v-else
        >
            {{ $t('label.apply_now') }}
        </template>
        <FontAwesomeIcon
            :icon="['fas', 'arrow-right']"
            size="md"
            class="afu-ml-3"
        />
    </C1Button>
</template>

<script>
    import ApplyJobMixin from './ApplyJobMixin';

    export default {
        name: 'ApplyJob',

        mixins: [
            ApplyJobMixin,
        ],
    };
</script>
<style>
.apply-btn-disabled {
    opacity: 0.4;
    cursor: none;
}
</style>